import ScrollReveal from 'scrollreveal'

const fn = {
  init: () => {
    document.querySelectorAll('.steps-grid').forEach((el) => fn.setupReveal(el))
  },

  setupReveal: () => {
    ScrollReveal().reveal('.steps-grid-item', {
      scale: 0,
      interval: 500,
      duration: 250,
      afterReveal: (el) => {
        const arrow = el.querySelector('.steps-grid-item-arrow svg')

        if (arrow) {
          arrow.classList.remove('opacity-0')
        }
      },
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
